import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import StarField from "../components/StarField";
import { setSeo } from "../lib/api";

export default function Privacy() {
  useEffect(() => {
    setSeo(
      "Privacy Policy | Shillong Lucky Ending",
      "Learn how Shillong Lucky Ending handles your data. We respect your privacy and collect only minimal information needed to run the website."
    );
  }, []);

  return (
    <div data-testid="privacy-page">
      <StarField />
      <Header />
      <div className="page-header">
        <h1>Privacy Policy</h1>
      </div>
      <div className="content-area">
        <div className="content-inner">
          <p>
            Your privacy is important to us. This Privacy Policy explains how <strong>Shillong Lucky Ending</strong>{" "}
            collects, uses and protects any information when you use our website. We are committed to keeping your
            information safe and handling it responsibly.
          </p>

          <h2>1. Information We Collect</h2>
          <p>
            Our website is primarily an informational portal, and we collect only minimal data. We may collect basic,
            non-personal information such as browser type, device information and anonymous usage statistics to help
            us improve the experience. If you voluntarily submit a message through our Contact Us form, we collect the
            name, email address and message you provide so that we can respond to you.
          </p>

          <h2>2. How We Use Your Information</h2>
          <p>
            Any information collected is used solely to operate and improve the website, respond to your enquiries and
            understand general usage patterns. We do not sell, rent or trade your personal information to third
            parties under any circumstances.
          </p>

          <h2>3. Cookies &amp; Analytics</h2>
          <p>
            Like most websites, we may use cookies and similar technologies to remember preferences and gather
            anonymous analytics. You can disable cookies through your browser settings at any time, though some
            features may not function as intended if you do so.
          </p>

          <h2>4. Data Security</h2>
          <p>
            We implement reasonable technical and organisational measures to safeguard the data we hold. However, no
            method of transmission over the internet is completely secure, and we cannot guarantee absolute security.
          </p>

          <h2>5. Third-Party Links</h2>
          <p>
            Our website may contain links to external sites. We are not responsible for the privacy practices or
            content of those third-party websites. We encourage you to review their privacy policies separately.
          </p>

          <h2>6. Children's Privacy</h2>
          <p>
            This website is intended for users who are <strong>18 years or older</strong>. We do not knowingly collect
            personal information from minors.
          </p>

          <h2>7. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Any changes will be posted on this page, and your
            continued use of the website indicates acceptance of the updated policy.
          </p>

          <h2>8. Contact</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us through our{" "}
            <strong>Contact Us</strong> page.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
